import { MOKA_SERVICE_HOST } from '../constants';

export const EXPORT_FILE = `${MOKA_SERVICE_HOST}/exporting/v1/exports`;
export const GET_EXPORT_FILE = (exportId) =>
  `${MOKA_SERVICE_HOST}/exporting/v1/exports/${exportId}`;
